export interface Actor {
  id: string;
  name: string;
  avatar: string;
  englishName: string;
  birthday: string;
  birthplace: string;
  height: string;
  signatureRoles: string[];
  intro: string;
  dramaIds: string[];
  roleInDrama: Record<string, string>;
  news: { title: string; date: string }[];
}

export const actors: Actor[] = [
  {
    id: "lin-wanqing",
    name: "林晚晴",
    englishName: "Lin Wanqing",
    avatar:
      "https://readdy.ai/api/search-image?query=elegant%20portrait%20of%20a%20Chinese%20actress%20with%20dark%20hair%20in%20a%20simple%20dark%20red%20dress%2C%20soft%20studio%20lighting%2C%20warm%20neutral%20background%2C%20refined%20editorial%20photography&width=600&height=800&seq=actor-linwanqing&orientation=portrait",
    birthday: "1992-04-18",
    birthplace: "江苏南京",
    height: "168cm",
    signatureRoles: ["苏曼姝", "沈知微", "何清欢"],
    intro:
      "林晚晴以细腻有层次的表演著称，擅长塑造外表坚韧、内心柔软的复杂女性角色。《风流女管家》中饰演的苏曼姝一角，被观众评价为“眼神里都是戏”，凭借这一角色获得了广泛关注。",
    dramaIds: ["fengliu-nvguandian", "chengshi-dengta", "chunfeng-xudu"],
    roleInDrama: {
      "fengliu-nvguandian": "苏曼姝（女管家）",
      "chengshi-dengta": "林青禾（医生）",
      "chunfeng-xudu": "周晚（女教师）",
    },
    news: [
      { title: "专访林晚晴：苏曼姝最难演的是“藏”", date: "2024-03-20" },
      { title: "《风流女管家》花絮公开，林晚晴一场哭戏一条过", date: "2024-02-08" },
    ],
  },
  {
    id: "lu-chenzhou",
    name: "陆沉舟",
    englishName: "Lu Chenzhou",
    avatar:
      "https://readdy.ai/api/search-image?query=portrait%20of%20a%20Chinese%20actor%20with%20sharp%20features%20in%20a%20dark%20tailored%20suit%2C%20studio%20lighting%2C%20warm%20neutral%20background%2C%20understated%20editorial%20photography&width=600&height=800&seq=actor-luchenzhou&orientation=portrait",
    birthday: "1990-11-02",
    birthplace: "北京",
    height: "185cm",
    signatureRoles: ["顾廷之", "沈砚之"],
    intro:
      "陆沉舟以沉稳克制的表演风格见长，常出演心思深沉的男主角。在《风流女管家》中，他将顾家当家人顾廷之的冷峻与隐忍刻画得入木三分，与林晚晴的对手戏张力十足。",
    dramaIds: ["fengliu-nvguandian", "guyun-changan"],
    roleInDrama: {
      "fengliu-nvguandian": "顾廷之（顾家当家人）",
      "guyun-changan": "沈砚之（寒门书生）",
    },
    news: [
      { title: "陆沉舟谈顾廷之：他不是冷漠，是不敢", date: "2024-03-15" },
      { title: "《古韵长安》杀青，陆沉舟再演谋士", date: "2023-09-02" },
    ],
  },
  {
    id: "su-jinyan",
    name: "苏锦言",
    englishName: "Su Jinyan",
    avatar:
      "https://readdy.ai/api/search-image?query=elegant%20portrait%20of%20a%20Chinese%20actress%20in%20a%20cream%20silk%20blouse%20with%20soft%20updo%20hair%2C%20gentle%20studio%20lighting%2C%20warm%20neutral%20background%2C%20classic%20editorial%20photography&width=600&height=800&seq=actor-sujinyan&orientation=portrait",
    birthday: "1994-07-26",
    birthplace: "浙江杭州",
    height: "165cm",
    signatureRoles: ["沈知微", "阿锦"],
    intro:
      "苏锦言气质清丽，擅长演绎独立而有主见的新女性形象。无论是《锦上往事》中坚韧的绣娘，还是《风流女管家》里思想新潮的沈知微，都给人留下深刻印象。",
    dramaIds: ["jinshang-wangshi", "fengliu-nvguandian"],
    roleInDrama: {
      "jinshang-wangshi": "阿锦（绣娘）",
      "fengliu-nvguandian": "沈知微（顾家表小姐）",
    },
    news: [
      { title: "苏锦言凭《锦上往事》获年度新人提名", date: "2023-12-01" },
      { title: "苏锦言：沈知微是最“清醒”的角色", date: "2024-01-11" },
    ],
  },
  {
    id: "qin-mu",
    name: "秦牧",
    englishName: "Qin Mu",
    avatar:
      "https://readdy.ai/api/search-image?query=portrait%20of%20a%20Chinese%20actor%20in%20a%20dark%20casual%20jacket%20with%20a%20calm%20expression%2C%20soft%20studio%20lighting%2C%20warm%20neutral%20background%2C%20clean%20editorial%20photography&width=600&height=800&seq=actor-qinmu&orientation=portrait",
    birthday: "1988-02-14",
    birthplace: "山东青岛",
    height: "182cm",
    signatureRoles: ["程亦寒", "顾家二爷"],
    intro:
      "秦牧戏路宽广，正剧与生活剧皆能驾驭。他在《城市灯塔》中饰演的救援队长有血有肉，在《风流女管家》中亦有精彩演绎，是公认的“戏骨型”演员。",
    dramaIds: ["chengshi-dengta", "fengliu-nvguandian", "yanhuo-nianhua"],
    roleInDrama: {
      "chengshi-dengta": "程亦寒（救援队长）",
      "fengliu-nvguandian": "顾廷安（顾家二爷）",
      "yanhuo-nianhua": "老周（街坊面馆老板）",
    },
    news: [
      { title: "秦牧：演救援队长前，我跟队训练了一个月", date: "2024-08-25" },
    ],
  },
  {
    id: "xie-yunshu",
    name: "谢云殊",
    englishName: "Xie Yunshu",
    avatar:
      "https://readdy.ai/api/search-image?query=elegant%20portrait%20of%20a%20Chinese%20actress%20with%20long%20wavy%20hair%20in%20a%20warm%20ochre%20dress%2C%20soft%20studio%20lighting%2C%20warm%20neutral%20background%2C%20tender%20editorial%20photography&width=600&height=800&seq=actor-xieyunshu&orientation=portrait",
    birthday: "1993-09-30",
    birthplace: "四川成都",
    height: "166cm",
    signatureRoles: ["白露", "苏母", "林青禾"],
    intro:
      "谢云殊以温柔而有力量的表演打动观众，善于刻画平凡生活中的女性形象。她在多部作品中塑造的母亲、医者等角色，均获得观众共情。",
    dramaIds: ["fengliu-nvguandian", "yanhuo-nianhua", "xingchen-zhixia"],
    roleInDrama: {
      "fengliu-nvguandian": "白露（顾家账房）",
      "yanhuo-nianhua": "苏梅（母亲）",
      "xingchen-zhixia": "林青禾（天文社指导）",
    },
    news: [
      { title: "谢云殊：白露这个角色藏着一条暗线", date: "2024-03-28" },
    ],
  },
  {
    id: "han-zhaoyang",
    name: "韩昭阳",
    englishName: "Han Zhaoyang",
    avatar:
      "https://readdy.ai/api/search-image?query=portrait%20of%20a%20young%20Chinese%20actor%20in%20a%20dark%20green%20shirt%20with%20a%20warm%20smile%2C%20soft%20studio%20lighting%2C%20warm%20neutral%20background%2C%20fresh%20editorial%20photography&width=600&height=800&seq=actor-hanzhaoyang&orientation=portrait",
    birthday: "1996-06-08",
    birthplace: "湖北武汉",
    height: "180cm",
    signatureRoles: ["洛星河", "顾家三公子"],
    intro:
      "韩昭阳是新生代演员中备受期待的一位，形象阳光、表演自然。在《星辰之下》中饰演的天文少年真挚动人，展现出不俗的潜力。",
    dramaIds: ["xingchen-zhixia", "jinshang-wangshi", "guyun-changan"],
    roleInDrama: {
      "xingchen-zhixia": "洛星河（天文社社长）",
      "jinshang-wangshi": "阿远（学徒）",
      "guyun-changan": "李承昭（少年将军）",
    },
    news: [
      { title: "韩昭阳：洛星河是我理想中的少年模样", date: "2024-02-20" },
    ],
  },
  {
    id: "shen-ruoxi",
    name: "沈若惜",
    englishName: "Shen Ruoxi",
    avatar:
      "https://readdy.ai/api/search-image?query=elegant%20portrait%20of%20a%20Chinese%20actress%20with%20soft%20bob%20hair%20in%20a%20muted%20rose%20blouse%2C%20delicate%20studio%20lighting%2C%20warm%20neutral%20background%2C%20literary%20editorial%20photography&width=600&height=800&seq=actor-shenruoxi&orientation=portrait",
    birthday: "1995-03-11",
    birthplace: "湖南长沙",
    height: "164cm",
    signatureRoles: ["周晚", "何知夏"],
    intro:
      "沈若惜气质文艺，台词功底扎实，多出演年代爱情题材。她在《春风徐渡》中塑造的女教师周晚，克制又深情，成为许多观众心中的白月光。",
    dramaIds: ["chunfeng-xudu", "jinshang-wangshi", "yanhuo-nianhua"],
    roleInDrama: {
      "chunfeng-xudu": "周晚（女教师）",
      "jinshang-wangshi": "何知夏（同行绣娘）",
      "yanhuo-nianhua": "苏念（女儿）",
    },
    news: [
      { title: "沈若惜：周晚的信，我写了一个月", date: "2023-05-20" },
    ],
  },
  {
    id: "gu-yanzhou",
    name: "顾衍之",
    englishName: "Gu Yanzhou",
    avatar:
      "https://readdy.ai/api/search-image?query=portrait%20of%20a%20mature%20Chinese%20actor%20with%20grey%20temples%20in%20a%20dark%20wool%20coat%2C%20dignified%20studio%20lighting%2C%20warm%20neutral%20background%2C%20cultivated%20editorial%20photography&width=600&height=800&seq=actor-guyanzhou&orientation=portrait",
    birthday: "1982-10-05",
    birthplace: "陕西西安",
    height: "181cm",
    signatureRoles: ["老戏骨·司空越", "周父"],
    intro:
      "顾衍之是资深实力派演员，气场沉稳，台词极具分量。无论是古装权臣还是年代父亲，他都能以寥寥数笔勾勒出人物的厚度，是年轻演员口中的“定海神针”。",
    dramaIds: ["guyun-changan", "chunfeng-xudu", "xingchen-zhixia"],
    roleInDrama: {
      "guyun-changan": "司空越（当朝重臣）",
      "chunfeng-xudu": "周父（老邮差）",
      "xingchen-zhixia": "陆教授（天文导师）",
    },
    news: [
      { title: "顾衍之：好角色不在戏份多少，在“立得住”", date: "2024-01-05" },
    ],
  },
];